// store.js
import { create } from "zustand";

export const useStore = create((set) => ({
  showEmploymentVerification: false,

  setShowEmploymentVerification: (value) =>
    set({ showEmploymentVerification: value }),

  toggleEmploymentVerification: () =>
    set((state) => ({
      showEmploymentVerification: !state.showEmploymentVerification,
    })),
}));
